// extracted by mini-css-extract-plugin
export default {"root":"loginForm_root__PEERO","root__body":"loginForm_root__body__ier-x","root__footer":"loginForm_root__footer__leDQX","error-message":"loginForm_error-message__tVPR8"};